export { default } from './shop-now-button';
export { shopNowButtonQuery } from './shop-now-button.query';
